<template>
  <div class="us_app">
    <section class="user_section">
      <div class="title jc">
        <h2>처방내역 상세 정보</h2>
      </div>

      <div v-if="rePrescript == true" class="title_actions">
        <button type="button" class="btn btn_md btn_brown" @click="fn_rePrescript">
          다시 처방하기
        </button>
      </div>

      <article class="view">
        <div class="table_list">
          <h3 class="tb_title">환자 정보</h3>
          <table class="write">
            <colgroup>
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
            </colgroup>
            <tbody>
              <tr>
                <th>성명</th>
                <td><span>{{ prescriptionInfo.patient_nm}}</span></td>
                <th>차트번호</th>
                <td><span>{{ prescriptionInfo.patient_chart_no }}</span></td>
                <th>나이/성별</th>
                <td><span>{{ prescriptionInfo.patient_age}}/{{ prescriptionInfo.patient_gender_nm}}</span></td>
                <th>연락처</th>
                <td><span>{{ formatPhoneNumber(prescriptionInfo.patient_tel_num) }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="prescriptionInfo.prescribe_type != 'P'" class="table_list">
          <h3 class="tb_title flex items-center justify-between">
            처방 정보
            <button v-if="prescriptionInfo.recipe_review_status == 'R'"
              class="btn btn_md btn_darkbrown btn_outline ml10"
              @click="fn_open_review"
            >
              비방 리뷰 등록
            </button>
          </h3>
          <table class="write">
            <colgroup>
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
            </colgroup>
            <tbody>
              <tr>
                <th>처방명</th>
                <td colspan="3">
                  <span>{{ prescriptionInfo.prescribe_nm}}</span>
                </td>
                <th>첩수</th>
                <td><span>{{ prescriptionInfo.prescribe_pack_cnt }} 첩</span></td>
                <th>팩수</th>
                <td><span>{{ prescriptionInfo.packs_cnt }} 팩</span></td>
              </tr>
              <tr>
                <th>감미제</th>
                <td>
                  <span v-if="prescriptionInfo.sweetener=='0'">없음</span>
                  <span v-if="prescriptionInfo.sweetener=='1'">단맛1단계</span>
                  <span v-if="prescriptionInfo.sweetener=='2'">단맛2단계</span>
                  <span v-if="prescriptionInfo.sweetener=='3'">단맛3단계</span>
                  <span v-if="prescriptionInfo.sweetener=='4'">단맛4단계</span>
                </td>
                <th>향기</th>
                <td>
                  <span v-if="prescriptionInfo.sweet_flavor==''">없음</span>
                  <span v-if="prescriptionInfo.sweet_flavor=='CA1'">약한카라멜향(0.5%)</span>
                  <span v-if="prescriptionInfo.sweet_flavor=='CA2'">약한카라멜향(1%)</span>
                  <span v-if="prescriptionInfo.sweet_flavor=='SB1'">약한딸기향(0.5%)</span>
                  <span v-if="prescriptionInfo.sweet_flavor=='SB2'">약한딸기향(1%)</span>
                  <span v-if="prescriptionInfo.sweet_flavor=='CH1'">약한초코향(0.5%</span>
                  <span v-if="prescriptionInfo.sweet_flavor=='CH2'">약한초코향(1%)</span>
                </td>
                <th>총약재량</th>
                <td><span>{{ prescriptionInfo.total_medicine_qnty }} g</span></td>
                <th>팩용량</th>
                <td><span>{{ prescriptionInfo.pack_capacity }} ml</span></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="prescriptionInfo.prescribe_type == 'P'" class="table_list">
          <h3 class="tb_title">약속상품정보</h3>
          <table class="write">
            <colgroup>
              <col width="300px" />
              <col width="430px" />
              <col width="300px" />
              <col width="430px" />
            </colgroup>
            <tbody>
            <tr>
              <th>처방명</th>
              <td>
                <span>{{ prescriptionInfo.prescribe_nm}}</span>
              </td>
              <th>약속상품타입</th>
              <td><span>{{ prescriptionInfo.promise_goods_type_nm }}</span></td>
            </tr>
            <tr>
              <th>판매금액</th>
              <td>
                {{fn_comma_won(prescriptionInfo.item_price)}}
              </td>
              <th>구매수량</th>
              <td>
                {{prescriptionInfo.item_quantity}}
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div v-if="prescriptionInfo.prescribe_type != 'P'" class="table_list">
          <h3 class="tb_title">약재 정보</h3>
          <textarea class="form_control" rows="3" readonly :value="medicineInfo" style="width:100%; resize:none;"></textarea>
        </div>

        <div v-if="prescriptionInfo.prescribe_type != 'P'" class="table_list">
          <h3 class="tb_title">포장 처리</h3>
          <table class="write">
            <colgroup>
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
            </colgroup>
            <tbody>
              <tr>
                <th>파우치</th>
                <td>
                    <div class="img_list">
                        <div>
                            <img 
                            v-if="prescriptionInfo && prescriptionInfo.pouch_img_file_id"
                            :src="'/file/getImgFile/' + prescriptionInfo.pouch_img_file_id" alt="">
                            <p>{{ prescriptionInfo.pouch_wraaper_nm }}</p>
                        </div>
                    </div> 
                </td>
                <th>포장</th>
                <td>
                  <div class="img_list">
                      <div>
                          <img v-if="prescriptionInfo && prescriptionInfo.wrapper_type_img_file_id"
                          :src="'/file/getImgFile/' + prescriptionInfo.wrapper_type_img_file_id" alt="">
                          <p>{{ prescriptionInfo.wrapper_type_nm }}</p>
                      </div>
                  </div>
                </td>
                <th>박스</th>
                <td>
                  <div class="img_list">
                      <div>
                          <img 
                          v-if="prescriptionInfo && prescriptionInfo.wrapper_type_img_file_id"
                          :src="'/file/getImgFile/' + prescriptionInfo.box_img_file_id" alt="">
                          <p>{{ prescriptionInfo.box_wrapper_nm }}</p>
                      </div>
                  </div>
                </td>
                <th>마킹</th>
                <td>
                  <span v-if="prescriptionInfo.mark_yn == 'Y'">환자이름,조제날짜</span>
                  <span v-else-if="prescriptionInfo.mark_yn == 'N'">마킹없음</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="prescriptionInfo.prescribe_type == 'P'" class="table_list">
          <h3 class="tb_title">처방정보</h3>
          <table class="write">
            <colgroup>
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
            </colgroup>
            <tbody>
            <tr>
              <th>복용법 첨부여부</th>
              <td>
                <span v-if=" prescriptionInfo.howtake_attach_yn == 'Y'">첨부</span>
                <span v-else>미첨부</span>
              </td>
              <th>사향인증서 첨부여부</th>
              <td>
                <span v-if="prescriptionInfo.musk_certificate_attach_yn == 'Y'">첨부</span>
                <span v-else>미첨부</span>
              </td>
              <th>10환 상자셋트 여부</th>
              <td>
                <span v-if="prescriptionInfo.gjd_set_yn == 'Y'">포함</span>
                <span v-else>선택안함</span>
              </td>
              <th>공진단 종이가방</th>
              <td>
                <span v-if="prescriptionInfo.gjd_gift_bag_yn == 'Y'">포함</span>
                <span v-else>선택안함</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="table_list">
          <h3 class="tb_title">보내는 사람</h3>
          <table class="write">
            <colgroup>
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
            </colgroup>
            <tbody>
              <tr>
                <th>이름</th>
                <td>
                  <span>{{ prescriptionInfo.send_nm }}</span>
                </td>
                <th>연락처</th>
                <td><span>{{ formatPhoneNumber(prescriptionInfo.send_tel_num) }}</span></td>
                <th>주소</th>
                <td colspan="3">
                  <span>({{prescriptionInfo.send_post_no}}) {{ prescriptionInfo.send_addr }} {{ prescriptionInfo.send_addr_dtl }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table_list">
          <h3 class="tb_title">받는 사람</h3>
          <table class="write">
            <colgroup>
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
            </colgroup>
            <tbody>
              <tr>
                <th>이름</th>
                <td>
                  <span>{{ prescriptionInfo.receive_nm }}</span>
                </td>
                <th>휴대폰</th>
                <td><span>{{ formatPhoneNumber(prescriptionInfo.receive_phone_num) }}</span></td>
                <th>주소</th>
                <td colspan="3">
                  <span>({{prescriptionInfo.receive_post_no}}) {{ prescriptionInfo.receive_addr }} {{ prescriptionInfo.receive_addr_dtl }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table_list">
          <h3 class="tb_title">요구 사항</h3>
          <table class="write">
            <colgroup>
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="15%" />
            </colgroup>
            <tbody>
              <tr v-if="prescriptionInfo.prescribe_type == 'P'">
                <th>요구 사항</th>
                <td colspan="7">
                  <pre>{{ prescriptionInfo.wrapper_req }}</pre>
                </td>
              </tr>
              <tr v-else>
                <th>포장 요구 사항</th>
                <td colspan="3">
                  <pre>{{ prescriptionInfo.wrapper_req }}</pre>
                </td>
                <th>배송 메모</th>
                <td colspan="3"><pre>{{ prescriptionInfo.delivery_memo }}</pre></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 복용법 -->
        <div class="table_list" v-if="prescriptionInfo.howtake_type == 'format'">
          <h3 class="tb_title">복약서</h3>
          <table class="write">
            <colgroup>
              <col width="10%" />
              <col width="90%" />
            </colgroup>
            <tbody>
            <tr>
              <th>복용방법</th>
              <td>{{howtakeInfo.countLavel}}</td>
            </tr>
            <tr>
              <th>복용시간</th>
              <td>{{howtakeInfo.timeLavel}}</td>
            </tr>
            <tr>
              <th>복용온도</th>
              <td>{{howtakeInfo.temperatureLavel}}</td>
            </tr>
            <tr>
              <th>금지음식</th>
              <td>{{howtakeInfo.forbiddenLavel}}</td>
            </tr>
            <tr v-if="howtakeInfo.forbiddenEtcLavel != ''">
              <th>기타금지음식</th>
              <td>{{howtakeInfo.forbiddenEtcLavel}}</td>
            </tr>
            </tbody>
          </table>
        </div>


        <div class="table_list" v-if="prescriptionInfo.howtake_type == 'file'">
          <h3 class="tb_title">복약서 첨부파일</h3>
          <table class="write">
            <colgroup>
              <col width="10%" />
              <col width="90%" />
            </colgroup>
            <tbody>
              <tr>
                <th>파일명</th>
                <td>
                  <span @click="fn_download_click(prescriptionInfo.howtake_file_id)" style="cursor:pointer; display:inline-flex; align-items:center;">
                    <img src="@/assets/img/icon/icon_clip.svg" alt="첨부파일" style="width:16px; height:16px; margin-right:4px;" />
                    <span>{{ prescriptionInfo.file_org_name }}</span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style="display:flex; gap:16px; align-items:flex-start;">
          <div class="table_list" style="flex:1;">
            <h3 class="tb_title">처리 상태</h3>
            <table class="write">
              <colgroup>
                <col width="10%" />
                <col width="40%" />
              </colgroup>
              <tbody>
              <tr>
                <th>결제 여부</th>
                <td><span>{{prescriptionInfo.payment_status_nm}}</span></td>
              </tr>
              <tr v-if="prescriptionInfo.payment_type == 'VB'">
                <th>결제은행</th>
                <td><span>{{prescriptionInfo.bank_name}}</span></td>
              </tr>
              <tr v-if="prescriptionInfo.payment_type == 'VB'">
                <th>결제계좌번호</th>
                <td><span>{{prescriptionInfo.account_number}}</span></td>
              </tr>
              <tr>
                <th>처리 상태</th>
                <td><span>{{prescriptionInfo.work_status_nm}}</span></td>
              </tr>
              <tr>
                <th>택배사</th>
                <td><span>{{prescriptionInfo.delivery_company_nm}}</span></td>
              </tr>
              <tr>
                <th>송장번호</th>
                <td>
                  <span>{{prescriptionInfo.delivery_no}}</span>
                  <button
                    v-if="prescriptionInfo.delivery_no"
                    class="btn btn_md btn_brown ml10"
                    style="height:30px; font-size:1.4rem; min-width:80px;"
                    @click="fn_open_delivery"
                  >배송조회</button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="table_list" style="flex:1;">
            <h3 class="tb_title">결제 비용</h3>
            <table class="write">
              <colgroup>
                <col width="10%" />
                <col width="40%" />
              </colgroup>
              <tbody>
                <tr v-if="prescriptionInfo.prescribe_type != 'P'">
                  <th>약재비</th>
                  <td><span>{{ fn_comma_won(prescriptionInfo.total_med_price) }}원</span></td>
                </tr>
                <tr v-if="prescriptionInfo.prescribe_type != 'P'">
                  <th>조제비</th>
                  <td><span>{{ fn_comma_won(prescriptionInfo.total_prepare_price) }} 원</span></td>
                </tr>
                <tr v-if="prescriptionInfo.prescribe_type != 'P'">
                  <th>탕전비</th>
                  <td>
                    <span>{{fn_comma_won(prescriptionInfo.total_tangjeon_price)}} 원</span>
                  </td>
                </tr>
                <tr v-if="prescriptionInfo.prescribe_type != 'P'">
                  <th>기타비</th>
                  <td><span>{{ fn_comma_won(prescriptionInfo.total_etc_price) }} 원</span></td>
                </tr>
                <tr v-if="prescriptionInfo.prescribe_type == 'P'">
                  <th>상품비</th>
                  <td><span>{{ fn_comma_won((prescriptionInfo.item_price*prescriptionInfo.item_quantity)) }} 원</span></td>
                </tr>
                <tr>
                  <th>제품비</th>
                  <td><span>{{ fn_comma_won(prescriptionInfo.total_product_price-(prescriptionInfo.item_price*prescriptionInfo.item_quantity)) }} 원</span></td>
                </tr>
                <tr>
                  <th>배송비</th>
                  <td><span>{{ fn_comma_won(prescriptionInfo.total_delivery_price) }} 원</span></td>
                </tr>
                <tr>
                  <th>사용예치금</th>
                  <td><span>{{ fn_comma_won(prescriptionInfo.deposit_used_price) }} 원</span></td>
                </tr>
                <tr>
                  <th>사용포인트</th>
                  <td><span>{{ fn_comma_won(prescriptionInfo.point_used_price) }} 원</span></td>
                </tr>
                <tr>
                  <th>결제금액</th>
                  <td><span>{{ fn_comma_won(prescriptionInfo.pay_price) }}원</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="bottom_box bn">
          <button class="btn btn_md btn_darkbrown" @click="$router.go(-1)">
            목록
          </button>
        </div>
      </article>
    </section>

    <b-modal id="reviewModal" title="비방 리뷰 등록" size="md">
      <div class="search user_modal">
        <div class="table_list">
          <table class="write">
            <colgroup>
              <col width="200" />
              <col width="30%" />
              <col width="200" />
              <col width="30%" />
            </colgroup>
            <tbody>
              <tr>
                <th>리뷰</th>
                <td colspan="3">
                  <textarea name="" id="" class="form_control" v-model="review_contents"></textarea>
                </td>
              </tr>
              <tr>
                <th>별점</th>
                <td colspan="3">
                  <div class="flex items-center gap4">
                    <b-icon
                      v-for="(star, index) in stars"
                      :key="index"
                      class="pointer"
                      :icon="getStarIcon(index)"
                      style="color: #ffd700"
                      @click="setRating(index, $event)"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <template #modal-footer="{ ok }">
        <b-button @click="() => fn_close_review(ok)" class="btn btn_md btn_brown btn_outline">
          취소
        </b-button>
        <b-button @click="fn_reg_review" class="btn btn_md btn_brown">저장</b-button>
      </template>
    </b-modal>

    <alert-modal 
      :id="'alert'"
      :text="showAlertMsg" 
      :btnRight="'확인'" 
      :oneBtn="false"
      :isShow="showAlert"
      :className="'btn_brown'"
      :closeEventValue="closeEventValue"
      @closeEvent="oncCloseEvent"
      v-on:update:showSetting="fn_showSet"
    />
    <alert-modal
        :id="'confirm'"
        :text="'재처방 하시겠습니까?'"
        :btnLeft="'취소'"
        :btnRight="'확인'"
        :oneBtn="true"
        :isShow="comfirmAlertShow"
        :className="'btn_brown'"
        @callback="fn_alert_close"
    />

<!--    <delivery-tracking-modal-->
<!--      :deliveryNo="prescriptionInfo.delivery_no || ''"-->
<!--      :deliveryCompanyCd="prescriptionInfo.delivery_company_code || ''"-->
<!--    />-->
<!--    -->

    <delivery-tracking-modal
        :deliveryNo="prescriptionInfo.delivery_no || ''"
        :deliveryCompanyCd="prescriptionInfo.delivery_company_code || '06'"
    />
  </div>
</template>

<script>

import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import AlertModal from "@/modal/common/alertModal.vue"
import alertutill from "@/mixin/alertModalUtill";
import DeliveryTrackingModal from "@/modal/user/deliveryTrackingModal.vue";
import {
  count,
  time,
  temperature,
  forbidden
} from '@/data/user/takingData'

export default {
  components: {
    AlertModal,
    DeliveryTrackingModal
  },
  mixins: [commonUtil,alertutill],
  data() {
    return {
      prescribe_seq : '',
      clinic_doctor_id : '',
      prescriptionInfo : {},
      medicineList : [],
      medicineInfo : '',
      howtakeInfo : {},
      
      rating: 0,
      stars: Array(5).fill(null),
      secret_prescription_seq : '',
      secret_clinic_doctor_id : '',
      write_clinic_doctor_id : '',
      review_contents : '', 
      
      rePrescript : false,
      comfirmAlertShow : false
    };
  },
  created(){
    this.prescribe_seq = this.$store.getters['detailSearchInfo/getSearchId']
    this.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
  },
  mounted(){
    this.fn_search();
  },
  methods: {
    fn_search(){
        //처방내역 상세 조회
        let param = new Object();
        param.prescribe_seq = this.prescribe_seq;
        param.clinic_doctor_id = this.clinic_doctor_id;

        //처방정보 상세조회
        axios
            .post("/api/user/mypage/getPrescriptionDetail", param)
            .then((res) => {
                console.log("@@@@@ getPrescriptionDetail : %o",res.data);
                this.prescriptionInfo = res.data.prescriptionInfo;
                this.medicineList = res.data.prescriptionMedicineList;

                if(this.prescriptionInfo.payment_status == 'CANC' &&
                  this.prescriptionInfo.prescribe_type != 'P'
                ){
                  this.rePrescript = true;
                }else if(this.prescriptionInfo.payment_status == 'COMP' &&
                  (this.prescriptionInfo.work_status == 'P10' || this.prescriptionInfo.work_status == 'P7') &&
                  this.prescriptionInfo.prescribe_type != 'P'
                ){
                  this.rePrescript = true;
                }else{
                  this.rePrescript = false;
                }

                //약재 표기법 변경
                for(let i = 0; i < this.medicineList.length; i++){
                  if(i === 0){
                    this.medicineInfo = this.medicineList[i].med_hrb_nm+" "+this.medicineList[i].medicine_use_qnty;
                  }else{
                    this.medicineInfo = this.medicineInfo + "," + this.medicineList[i].med_hrb_nm+" "+this.medicineList[i].medicine_use_qnty;
                  }
                }

                // 복약서 전용서식 보여주기 처리 - 20260716
                if(this.prescriptionInfo.howtake_type === 'format'){
                  //복용횟수 관련 처리 - 복용법 정보가 있는 경우
                  if(this.prescriptionInfo.howtake_count !== ''){
                    //기타가 아닌 경우
                    if(this.prescriptionInfo.howtake_count !== 'etc'){
                      let label = count.find(item => item.value === this.prescriptionInfo.howtake_count);
                      this.howtakeInfo.countLavel = label.text;
                    } else{
                      this.howtakeInfo.countLavel = this.prescriptionInfo.howtake_count_etc;
                    }
                  }

                  //복용시간 관련 처리 - 복용법 정보가 있는 경우
                  if(this.prescriptionInfo.howtake_time !== ''){
                    //기타가 아닌 경우
                    if(this.prescriptionInfo.howtake_time !== 'etc'){
                      let label = time.find(item => item.value === this.prescriptionInfo.howtake_time);
                      this.howtakeInfo.timeLavel = label.text;
                    } else{
                      this.howtakeInfo.timeLavel = this.prescriptionInfo.howtake_time_etc;
                    }
                  }

                  //복용온도 관련 처리 - 복용법 정보가 있는 경우
                  if(this.prescriptionInfo.howtake_temperature !== ''){
                      let label = temperature.find(item => item.value === this.prescriptionInfo.howtake_temperature);
                      this.howtakeInfo.temperatureLavel = label.text;
                  }

                  //금지음식 관련 처리 - 복용법 정보가 있는 경우
                  if(this.prescriptionInfo.howtake_forbidden !== ''){

                    let forbiddenList = this.prescriptionInfo.howtake_forbidden.split(/\s*,\s*/);

                    const forbiddenLabel = forbidden
                        .filter(item => forbiddenList.includes(item.value) && item.value !== 'etc')
                        .map(item => item.text)
                        .join(', ')

                    this.howtakeInfo.forbiddenLavel = forbiddenLabel;

                    const hasEtc = forbiddenList.includes('etc')
                    if(hasEtc){
                      this.howtakeInfo.forbiddenEtcLavel = this.prescriptionInfo.howtake_forbidden_etc;
                    }
                  }
                }


            })
            .catch((err) => console.log(err));
            
    },
    setRating(index, event) {
      const { offsetX, target } = event;
      const starWidth = target.getBoundingClientRect().width;
      const isHalf = offsetX < starWidth / 2;
      this.rating = index + (isHalf ? 0.5 : 1);
    },
    getStarIcon(index) {
      if (this.rating >= index + 1) return "star-fill";
      if (this.rating >= index + 0.5) return "star-half";
      return "star";
    },
    fn_open_delivery() {
      this.$bvModal.show('deliveryTrackingModal');
    },
    fn_move_list_page(){
        this.$store.dispatch('detailSearchInfo/setSearchId', ''); 
        this.$router.push("/mypage/PrescriptionList");
    },
    fn_open_review(){
      this.$bvModal.show('reviewModal');

        this.secret_prescription_seq = this.prescriptionInfo.secret_prescription_seq;
        this.secret_clinic_doctor_id = this.prescriptionInfo.secret_clinic_doctor_id;
        this.write_clinic_doctor_id = this.clinic_doctor_id;

    },
    fn_close_review(ok) {
       
      this.prescribe_seq = '';
      this.secret_prescription_seq = '';
      this.secret_clinic_doctor_id = '';
      this.write_clinic_doctor_id = '';
      this.review_contents = '';
      this.rating = 0;
      
      ok();
    },
    fn_reg_review(){

      //환자seq 정보 셋팅
      let param = new Object();
      param.prescribe_seq = this.prescribe_seq;
      param.secret_prescription_seq = this.secret_prescription_seq;
      param.secret_clinic_doctor_id = this.secret_clinic_doctor_id;
      param.write_clinic_doctor_id = this.write_clinic_doctor_id;
      param.rating = this.rating;
      param.review_contents = this.review_contents

      console.log("@@@@@@ review param : %o", param);
        
      axios
          .post("/api/user/mypage/regScretPrescriptionReview", param)
          .then((res) => {
              console.log("@@@@ res : %o",res);                       
              
              let msg = "저장되었습니다.";
              this.fn_open_alert_close(msg); 
          })
          .catch((err) => console.log(err));

      },
      oncCloseEvent(){
        this.$bvModal.hide('reviewModal');

        this.prescriptionInfo.recipe_review_status = 'N';

      },
      fn_rePrescript(){
        this.comfirmAlertShow = true;
      },
      fn_alert_close(type){

        this.comfirmAlertShow = false;
                      
        if(type == 'ok'){
          this.$store.dispatch('applicationInfo/setRePresciptSeq', this.prescribe_seq);

          if(this.prescriptionInfo.prescribe_type == "T"){
            this.$router.push("/application");
          }else if(this.prescriptionInfo.prescribe_type == "I"){
            this.$router.push("/insurance");
          }
          
        }

      },
      fn_download_click(fileId){
        this.fn_download_file(fileId);
      },
  },
};
</script>
